import Vue from 'vue'
import axios from 'axios'
window.Vue = Vue;

Vue.component('favorite', require('./components/Favorite.vue').default);
const app = new Vue({
    el: '#faves',
});
